module.exports = __webpack_public_path__ + "img/maintest.5d1221ea.png";